// src/pages/LoginPage.jsx
import React, { useState } from "react";
import { useAuth } from "../../utils/session/AuthContext";
import { useNavigate } from "react-router-dom";
import RowColLayout from "../../components/RowColLayout";
import FormField from "../../components/FormField";
import MyButton from "../../components/MyButton";
import logo from '../../assets/images/logos/copa_logo_white.png'
import email from '../../assets/icons/small_icons/correo.svg'
import pass from '../../assets/icons/small_icons/contrasena.svg'
import franjasup from '../../assets/images/logos/franjaSup.svg'
import franjainf from '../../assets/images/logos/franjaInf.svg'
import CenteredColumnLayout from '../../components/CenteredColumnLayout';
import LiquidContainer from "../../components/LiquidContainer";
import { recoverPassword } from "../../api/user";
import whats from '../../assets/icons/small_icons/WHATSAPP_white.svg';
import { Link } from "react-router-dom";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  // --- States ---
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [forgotPass, setForgotPass] = useState(false); // Controls the UI switch
  const [loading, setLoading] = useState(false);

  // --- Handlers ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const lowerUsername = username.trim().toLowerCase();

    try {
      await login(lowerUsername, password);
      navigate("/landing");
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    }
  };

  const handleRecover = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await recoverPassword({ email: username }); 
      
      // Use the message sent by Django
      alert(response.message); 
      
      setForgotPass(false);
    } catch (err) {
      // If the API is down or there's a 400/500 error
      setError(err.response?.data?.error || "Error de conexión con el servidor");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className='container-fluid d-flex flex-column justify-content-between m-0 p-0' 
      style={{
        minHeight: '100vh',
        backgroundImage: "url('/static/images/backLogin.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>

      <RowColLayout />

      <div className="row m-0 p-0" style={{ height: "7vh" }}>
        <div className="col-4 h-100"></div>
        <div className="col-4 h-100"></div>
        <div className="col-4 h-100 m-0 p-0">
          <img src={franjasup} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "right top" }} />
        </div>
      </div>

      <CenteredColumnLayout>
        <img src={logo} style={{ maxHeight: "26vh", maxWidth: "210px" }} />
      </CenteredColumnLayout>

      {!forgotPass ? (
        /* --- LOGIN UI --- */
        <CenteredColumnLayout>
          <LiquidContainer>
            <div className="signin w-100 m-0 px-4 py-5">
              <form onSubmit={handleSubmit} className="d-flex flex-column justify-content-center align-items-center">
                <FormField
                  label="ID Correo"
                  name="username"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  icon={email}
                  placeholder="ID Correo"
                />
                <FormField
                  label="Contraseña"
                  name="password"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  icon={pass}
                  placeholder="Contraseña"
                />
                <div className="d-flex justify-content-center align-items-center mt-4" style={{ width: "70%" }}>
                  <MyButton text="Entrar" type="submit" />
                </div>
              </form>

              <div className="resetPass text-center mt-3">
                <h3 
                  onClick={() => setForgotPass(true)} 
                  style={{ cursor: 'pointer', fontSize: '1rem', textDecoration: 'underline' }}
                >
                  ¿Olvidaste tu contraseña?
                </h3>
              </div>

                          
            <Link to="/registration" aria-label="Go to registration" style={{ textDecoration: "none" }}>
              <div className="linkRegistration text-black text-center mt-3">
                <h2 
                  style={{ cursor: 'pointer', fontSize: '1rem', textDecoration: 'underline' }}
                >
                  ¡Registrate aquí!
                </h2>
              </div>
              </Link>
            </div>
          </LiquidContainer>
        </CenteredColumnLayout>
      ) : (
        /* --- RECOVERY UI --- */
        <CenteredColumnLayout>
          <LiquidContainer>
            <div className="signin w-100 m-0 px-4 py-5">
              <h2 className="text-center text-black mb-4">Recuperar Contraseña</h2>
              <form onSubmit={handleRecover} className="d-flex flex-column justify-content-center align-items-center">
                <FormField
                  label="Introduce tu correo"
                  name="username"
                  type="text"
                  placeholder="tuemail@ejemplo.com"
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  icon={email}
                />
                <div className="d-flex flex-column justify-content-center align-items-center mt-4" style={{ width: "70%" }}>
                  <MyButton text="Enviar Enlace" type="submit" />
                  <p 
                    className="mt-3 text-black" 
                    style={{ cursor: 'pointer', textDecoration: 'underline' }} 
                    onClick={() => setForgotPass(false)}
                  >
                    Volver al Login
                  </p>
                </div>
              </form>
            </div>
          </LiquidContainer>
        </CenteredColumnLayout>
      )}

      <RowColLayout>
        {error && (
          <div className="alert alert-danger text-center mt-1" role="alert">
            {error}
          </div>
        )}
      </RowColLayout>

      <div className="row m-0 p-0" style={{ height: "7vh" }}>
        <div className="col-4 h-100 m-0 p-0">
          <img src={franjainf} style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "left bottom" }} />
        </div>
        <div className="col-4 h-100"></div>
        <div className="col-4 h-100"></div>
      </div>
      <RowColLayout />

      {/* Floating WhatsApp Bubble */}
      <a
        href="https://wa.me/525656859418"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '15px',
          right: '30px',
          backgroundColor: '#25d366', // Official WhatsApp Green
          color: '#FFF',
          borderRadius: '50px',
          textAlign: 'center',
          fontSize: '30px',
          boxShadow: '2px 2px 3px #999',
          zIndex: 1000,
          width: '60px',
          height: '60px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textDecoration: 'none'
        }}
        aria-label="Contact via WhatsApp"
      >
        <img 
          src={whats} 
          alt="WhatsApp help" 
          style={{ width: "35px", height: "35px" }} 
        />
      </a>
    </div>
  );
}